import React from "react";

import AccountLayout from "../../components/AccountLayout";
import AccountRoute from "../../components/AccountRoute";
import AppLayout from "../../components/AppLayout";
import Rewards from "../../page-components/MyRewards";

function RewardsPage(props) {
  return (
    <AppLayout withFooter={false} pageTitle="Rewards" shouldIndex={false}>
      <AccountLayout
        {...props}
        render={(props) => (
          <AccountRoute
            path="/account/rewards"
            Component={Rewards}
            {...props}
          />
        )}
      />
    </AppLayout>
  );
}

export default RewardsPage;
